var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundAllLevel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 649,
    viewBox: "0 0 1200 649",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1199.5 338.929L1198.78 649C1198.78 649 910.354 649 716.425 649C288.316 649 0 649 0 649V335C0 311 3.92707 294.114 20.2459 284.85C85.2262 247.964 141.665 321.737 193.004 295.39C244.342 269.044 196.266 36.1317 275.053 21.1452C353.84 6.15878 403.444 156.009 499.734 156.009C596.025 156.009 581.44 6.14463 694.042 0.164191C806.644 -5.81625 803.664 153.563 871.398 153.563C939.131 153.563 911.669 89.6376 1017.84 87.7572C1124.02 85.8768 1153.31 313.374 1198.78 338.526C1199.02 338.681 1199.26 338.809 1199.5 338.929Z",
    fill: "url(#paint0_linear_704_1075)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_704_1075",
    x1: 571.494,
    y1: 39.6309,
    x2: 573,
    y2: 594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6FA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundAllLevel);
export default __webpack_public_path__ + "static/media/background-all-level.c82a8d47be6de66b97f554529385b391.svg";
export { ForwardRef as ReactComponent };